import axiosIns from '@/api/axios';

const cleanParams = (args = {}) => Object.fromEntries(
    Object.entries(args || {}).filter(([, value]) => value !== null && value !== undefined && value !== '')
)

export const GET_DASHBOARD_PERSONAL = (args) => {
    return axiosIns.get('/dashboard-personal', args)
}

export const GET_DASHBOARD_PERSONAL_DATA = (args) => {
    let nik = "";
    if (args != "") {
        nik = `?${args}`
    }
    return axiosIns.get(`/dashboard-personal-data${nik}`, args)
}
export const GET_DASHBOARD_MANAGER_DATA = (args) => {
    return axiosIns.get('/dashboard-manager-data', args)
}
export const GET_DASHBOARD_HR_DATA = (args) => {
    return axiosIns.post('/dashboard-hr-data', args)
}
export const GET_DASHBOARD_HR_DATA_ADOPTION = (args) => {
    return axiosIns.post('/dashboard-hr-data/adoption-coverage', args)
}

export const GET_ACTIVITY = (args) => {
    return axiosIns.get(`/logs?${args}`)
}

// =======
// PARTNER
// =======
export const GET_DASHBOARD_SUMMARY_PARTNER = (args) => {
    return axiosIns.get('/dashboard/summary/partner', { params: cleanParams(args) })
}

export const GET_DASHBOARD_TIME_SERIES_PARTNER = (args) => {
    return axiosIns.get('/dashboard/time-series/partner', { params: cleanParams(args) })
}

export const GET_DASHBOARD_ROLE_COMPETENCIES_PARTNER = (args) => {
    return axiosIns.get('/dashboard/role-competencies/partner', { params: cleanParams(args) })
}

export const GET_DASHBOARD_ROLE_COMPETENCIES_PARTNER_DETAIL = (roleCompetencyId, args) => {
    return axiosIns.get(`/dashboard/role-competencies/partner/${roleCompetencyId}`, { params: cleanParams(args) })
}

export const GET_DASHBOARD_EMPLOYEES_PARTNER = (roleCompetencyId, args) => {
    return axiosIns.get(`/dashboard/employees/partner/${roleCompetencyId}`, { params: cleanParams(args) })
}

// ============
// HSE TRAINING
// ============
export const GET_DASHBOARD_SUMMARY_HSE = (args) => {
    return axiosIns.get('/dashboard/summary/hse', { params: cleanParams(args) })
}

export const GET_DASHBOARD_TIME_SERIES_HSE = (args) => {
    return axiosIns.get('/dashboard/time-series/hse', { params: cleanParams(args) })
}

export const GET_DASHBOARD_ROLE_COMPETENCIES_HSE = (args) => {
    return axiosIns.get('/dashboard/role-competencies/hse', { params: cleanParams(args) })
}

export const GET_DASHBOARD_ROLE_COMPETENCIES_HSE_DETAIL = (roleCompetencyId, args) => {
    return axiosIns.get(`/dashboard/role-competencies/hse/${roleCompetencyId}`, { params: cleanParams(args) })
}

export const GET_DASHBOARD_EMPLOYEES_HSE = (roleCompetencyId, args) => {
    return axiosIns.get(`/dashboard/employees/hse/${roleCompetencyId}`, { params: cleanParams(args) })
}

// ==================
// HR OPERATIONS SITE
// ==================
export const GET_DASHBOARD_SUMMARY_SITE = (args) => {
    return axiosIns.get('/dashboard/summary/site', { params: cleanParams(args) })
}

export const GET_DASHBOARD_TIME_SERIES_SITE = (args) => {
    return axiosIns.get('/dashboard/time-series/site', { params: cleanParams(args) })
}

export const GET_DASHBOARD_ROLE_COMPETENCIES_SITE = (args) => {
    return axiosIns.get('/dashboard/role-competencies/site', { params: cleanParams(args) })
}

export const GET_DASHBOARD_ROLE_COMPETENCIES_SITE_DETAIL = (roleCompetencyId, args) => {
    return axiosIns.get(`/dashboard/role-competencies/site/${roleCompetencyId}`, { params: cleanParams(args) })
}

export const GET_DASHBOARD_EMPLOYEES_SITE = (roleCompetencyId, args) => {
    return axiosIns.get(`/dashboard/employees/site/${roleCompetencyId}`, { params: cleanParams(args) })
}

// ========
// EMPLOYEE
// ========
export const GET_DASHBOARD_SUMMARY_EMPLOYEE = (args) => {
    return axiosIns.get('/dashboard/summary/employee', { params: cleanParams(args) })
}

export const GET_DASHBOARD_TIME_SERIES_EMPLOYEE = (args) => {
    return axiosIns.get('/dashboard/time-series/employee', { params: cleanParams(args) })
}

export const GET_DASHBOARD_DETAIL_EMPLOYEE = (args) => {
    return axiosIns.get('/dashboard/detail/employee', { params: cleanParams(args) })
}

// ========
// INTERNAL
// ========
export const GET_DASHBOARD_SUMMARY_INTERNAL = (args) => {
    return axiosIns.get('/dashboard/summary/internal', { params: cleanParams(args) })
}

export const GET_DASHBOARD_TIME_SERIES_INTERNAL = (args) => {
    return axiosIns.get('/dashboard/time-series/internal', { params: cleanParams(args) })
}

export const GET_DASHBOARD_ROLE_COMPETENCIES_INTERNAL = (args) => {
    return axiosIns.get('/dashboard/role-competencies/internal', { params: cleanParams(args) })
}

export const GET_DASHBOARD_COMPETENCIES_INTERNAL = (args) => {
    return axiosIns.get('/dashboard/competencies/internal', { params: cleanParams(args) })
}

export const GET_DASHBOARD_COMPETENCIES_INTERNAL_DETAIL = (competencyId, args) => {
    return axiosIns.get(`/dashboard/competencies/internal/${competencyId}`, { params: cleanParams(args) })
}

export const GET_DASHBOARD_COMPETENCIES_INTERNAL_EMPLOYEES = (competencyId, args) => {
    return axiosIns.get(`/dashboard/competencies/internal/${competencyId}`, { params: cleanParams(args) })
}

export const GET_DASHBOARD_ROLE_COMPETENCIES_INTERNAL_DETAIL = (roleCompetencyId, args) => {
    return axiosIns.get(`/dashboard/role-competencies/internal/${roleCompetencyId}`, { params: cleanParams(args) })
}

export const GET_DASHBOARD_EMPLOYEES_INTERNAL = (roleCompetencyId, args) => {
    return axiosIns.get(`/dashboard/employees/internal/${roleCompetencyId}`, { params: cleanParams(args) })
}

// ==================
// DASHBOARD COMPANIES
// ==================
export const GET_DASHBOARD_COMPANIES = (args) => {
    return axiosIns.get('/dashboard/companies', { params: cleanParams(args) })
}

export const GET_DASHBOARD_COMPANY_OPTIONS = (args) => {
    return axiosIns.get('/dashboard/company-options', { params: cleanParams(args) })
}

export const GET_DASHBOARD_COMPANY_EMPLOYEES = (args) => {
    return axiosIns.get('/dashboard/companies/employees', { params: cleanParams(args) })
}

// ==================
// REPORT EXPORT
// ==================
export { EXPORT_COMMON_REPORT as EXPORT_DASHBOARD_REPORT } from '@/api/common/reports'
